import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagDO = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M.862 31.521C3.17 40.086 9.914 46.83 18.479 49.138V31.521H.862Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M18.479.86C9.914 3.17 3.169 9.913.862 18.477h17.617V.86Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M49.138 18.477C46.83 9.913 40.086 3.17 31.521.86v17.617h17.617Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M31.521 49.138c8.565-2.308 15.309-9.052 17.617-17.617H31.521v17.617Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M31.522 25a6.522 6.522 0 1 1-13.043 0c0-3.602 6.521-6.521 6.521-6.521s6.522 2.92 6.522 6.521Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M18.479 25a6.522 6.522 0 1 1 13.043 0"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M21.331 21.74v4.076a3.668 3.668 0 0 0 7.337 0v-4.077h-7.337Z"
}));
FlagDO.displayName = 'FlagDO';
export default withFlagWrapper(FlagDO);
//# sourceMappingURL=index.js.map